import WidgetsOutlinedIcon from "@mui/icons-material/WidgetsOutlined";
// import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined";
// import SyncLockOutlinedIcon from "@mui/icons-material/SyncLockOutlined";
import EventIcon from "@mui/icons-material/Event";
import AssignmentIcon from "@mui/icons-material/Assignment";
import WorkOutlineOutlinedIcon from "@mui/icons-material/WorkOutlineOutlined";
import EventBusyIcon from "@mui/icons-material/EventBusy";
import PortraitIcon from "@mui/icons-material/Portrait";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";

// import DashBoard from "../../assetes/PublicHoliday2.svgvg";
// import Client from "../../assets/images/Client.svg";
// import Project from "../../assets/images/Project.svg";
// import Task from "../../assets/images/Task.svg";
// import Leave from "../../assets/images/Leave.svg";
// import PublicHoliday from "../../assets/images/PublicHoliday.svg";

import DashBoard from "../../assets/images/Dashboard.svg";
import DashBoard_Green from "../../assets/images/Dashboard_Green.svg";
import Employee from "../../assets/images/Employee.svg";
import Employee_Green from "../../assets/images/Employee_Green.svg";
import Client from "../../assets/images/Client.svg";
import Client_Green from "../../assets/images/Client_Green.svg";
import { CiFileOn } from "react-icons/ci";
import Project from "../../assets/images/Project.svg";
import Project_Green from "../../assets/images/Project_Green.svg";
import Task from "../../assets/images/Task.svg";
import Task_Green from "../../assets/images/Task_Green.svg";
import Bug from "../../assets/images/Bug.svg";
import Bug_Green from "../../assets/images/Bug_Green.svg";
import Leave from "../../assets/images/Leave.svg";
import Leave_Green from "../../assets/images/Leave_Green.svg";
import PublicHoliday from "../../assets/images/PublicHoliday.svg";
import PublicHoliday_Green from "../../assets/images/PublicHoliday_Green.svg";
import Attendance from "../../assets/images/Attendance.svg";
import SecurityIcon from "@mui/icons-material/Security";
import { CloudDownload, Speed as SpeedIcon } from "@mui/icons-material";
import BusinessIcon from "@mui/icons-material/Business";

const superAdminMenu = [
  {
    title: "Dashboard",
    path: "dashboard",
    icon: (
      <img
        src={DashBoard}
        alt="Dashboard Icon"
      // style={{ width: "19px", height: "18px" }}
      />
    ),
    icon2: (
      <img
        src={DashBoard_Green}
        alt="Dashboard Icon"
      // style={{ width: "19px", height: "18px" }}
      />
    ),
    subMenu: [],
  },
  // {
  //   title: "User",
  //   path: "user",
  //   icon: <PeopleAltOutlinedIcon />,
  //   subMenu: [],
  // },
  {
    title: "Tasks",
    path: "tasks",
    icon: (
      <img
        src={Task}
        alt="Task Icon"
      // style={{ width: "18px", height: "18px" }}
      />
    ),
    icon2: (
      <img
        src={Task_Green}
        alt="Task Icon"
      // style={{ width: "18px", height: "18px" }}
      />
    ),
    subMenu: [
      {
        title: "Parent Task",
        path: "parentTask",
        icon: (
          <img
            src={Task}
            alt="Task Icon"
          // style={{ width: "18px", height: "18px" }}
          />
        ),
        icon2: (
          <img
            src={Task_Green}
            alt="Task Icon"
          // style={{ width: "18px", height: "18px" }}
          />
        ),
        subMenu: [],
      },
      {
        title: "Task",
        path: "taskManagement",
        icon: (
          <img
            src={Task}
            alt="Task Icon"
          // style={{ width: "18px", height: "18px" }}
          />
        ),
        icon2: (
          <img
            src={Task_Green}
            alt="Task Icon"
          // style={{ width: "18px", height: "18px" }}
          />
        ),
        subMenu: [],
      },
      {
        title: "Bugs",
        path: "bugManagement",
        icon: (
          <img
            src={Bug}
            alt="Bug Icon"
          // style={{ width: "18px", height: "18px" }}
          />
        ),
        icon2: (
          <img
            src={Bug_Green}
            alt="Bug Icon"
          // style={{ width: "18px", height: "18px" }}
          />
        ),
        subMenu: [],
      },
      {
        title: "Time Sheet",
        path: "timeSheet",
        icon: (
          <img
            src={Task}
            alt="Time Sheet Icon"
          // style={{ width: "18px", height: "18px" }}
          />
        ),
        icon2: (
          <img
            src={Task_Green}
            alt="Time Sheet Icon"
          // style={{ width: "18px", height: "18px" }}
          />
        ),
        subMenu: [],
      },
    ],
  },
  {
    title: "Todo Task",
    path: "todoTask",
    icon: (
      <img
        src={Task}
        alt="Task Icon"
      // style={{ width: "18px", height: "18px" }}
      />
    ),
    icon2: (
      <img
        src={Task_Green}
        alt="Task Icon"
      // style={{ width: "18px", height: "18px" }}
      />
    ),
    subMenu: [],
  },
  {
    title: "Users",
    path: "users",
    icon: (
      <img
        src={Employee}
        alt="Employee Icon"
      // style={{ width: "19px", height: "18px" }}
      />
    ),
    icon2: (
      <img
        src={Employee_Green}
        alt="Employee Icon"
      // style={{ width: "19px", height: "18px" }}
      />
    ),
    subMenu: [
      {
        title: "Employee",
        path: "employee",
        icon: (
          <img
            src={Employee}
            alt="Employee Icon"
          // style={{ width: "19px", height: "18px" }}
          />
        ),
        icon2: (
          <img
            src={Employee_Green}
            alt="Employee Icon"
          // style={{ width: "19px", height: "18px" }}
          />
        ),
        subMenu: [],
      },
      {
        title: "Manager",
        path: "Manager",
        icon: (
          <img
            src={Employee}
            alt="Employee Icon"
          // style={{ width: "19px", height: "18px" }}
          />
        ),
        icon2: (
          <img
            src={Employee_Green}
            alt="Employee Icon"
          // style={{ width: "19px", height: "18px" }}
          />
        ),
        subMenu: [],
      },
      {
        title: "Client",
        path: "client",
        icon: (
          <img
            src={Client}
            alt="Client Icon"
          // style={{ width: "18px", height: "16px" }}
          />
        ),
        icon2: (
          <img
            src={Client_Green}
            alt="Client Icon"
          // style={{ width: "18px", height: "16px" }}
          />
        ),
        subMenu: [],
      },
    ],
  },
  // {
  //   title: "Request",
  //   path: "request",
  //   icon: <img src={Task} alt="Task Icon" />,
  //   icon2: <img src={Task_Green} alt="Task Icon" />,
  //   subMenu: [],
  // },
  {
    title: "Leave",
    path: "leaveManagement",
    icon: (
      <img
        src={Leave}
        alt="Leave Icon"
      // style={{ width: "21px", height: "18px" }}
      />
    ),
    icon2: (
      <img
        src={Leave_Green}
        alt="Leave Icon"
      // style={{ width: "21px", height: "18px" }}
      />
    ),
    subMenu: [
      {
        title: "Approvel Pending",
        path: "leaveManagement",
        icon: (
          <img
            src={Leave}
            alt="Leave Icon"
          />
        ),
        icon2: (
          <img
            src={Leave_Green}
            alt="Leave Icon"
          />
        ),
      },
      {
        title: "Compoff",
        path: "earnedLeaveRequests",
        icon: (
          <img
            src={Leave}
            alt="Leave Icon"
          />
        ),
        icon2: (
          <img
            src={Leave_Green}
            alt="Leave Icon"
          />
        ),
      },
      {
        title: "Leave Summary",
        path: "leaveSummary",
        icon: (
          <img
            src={Leave}
            alt="Leave Icon"
          />
        ),
        icon2: (
          <img
            src={Leave_Green}
            alt="Leave Icon"
          />
        ),
      },
    ],
  },
  {
    title: "Attendance",
    path: "#",
    icon: (
      <img
        src={Attendance}
        alt="Task Icon"
      // style={{ width: "18px", height: "18px" }}
      />
    ),
    icon2: (
      <img
        src={Attendance}
        alt="Task Icon"
      // style={{ width: "18px", height: "18px" }}
      />
    ),
    subMenu: [
      {
        title: "Attendance Report",
        path: "attendance",
        icon: (
          <img
            src={Attendance}
            alt="Attendance Icon"
          // style={{ width: "18px", height: "16px" }}
          />
        ),
        icon2: (
          <img
            src={Attendance}
            alt="Attendance Icon"
          // style={{ width: "18px", height: "16px" }}
          />
        ),
      },
      {
        title: "Reverted",
        path: "reverted",
        icon: (
          <img
            src={""}
            alt="Reverted Icon"
          // style={{ width: "18px", height: "16px" }}
          />
        ),
        icon2: (
          <img
            src={Attendance}
            alt="Reverted Icon"
          // style={{ width: "18px", height: "16px" }}
          />
        ),
      },
    ]
  },
  {
    title: "Daily Reports",
    path: "time-tracker",
    icon: (
      <img
        src={Client}
        alt="Time Tracker Icon"
      // style={{ width: "18px", height: "16px" }}
      />
    ),
    icon2: (
      <img
        src={Client_Green}
        alt="Time Tracker Icon"
      // style={{ width: "18px", height: "16px" }}
      />
    ),
    subMenu: [
      {
        title: "Work Activity",
        path: "time-tracker",
        icon: (
          <img
            src={Client}
            alt="Time Tracker Icon"
          // style={{ width: "18px", height: "16px" }}
          />
        ),
        icon2: (
          <img
            src={Client_Green}
            alt="Time Tracker Icon"
          // style={{ width: "18px", height: "16px" }}
          />
        ),
        subMenu: [],
      },
      {
        title: "App & Site Usage",
        path: "app-usage",
        icon: (
          <img
            src={Client}
            alt="App Usage Icon"
          />
        ),
        icon2: (
          <img
            src={Client_Green}
            alt="App Usage Icon"
          />
        ),
        subMenu: [],
      },
      {
        title: "Note Approvals",
        path: "note-approvals",
        icon: (
          <img
            src={Client}
            alt="Note Approvals Icon"
          />
        ),
        icon2: (
          <img
            src={Client_Green}
            alt="Note Approvals Icon"
          />
        ),
        subMenu: [],
      },
      {
        title: "Daily Working Report",
        path: "DailyWorkingReport",
        icon: (
          <img
            src={Task}
            alt="Task Icon"
          // style={{ width: "18px", height: "18px" }}
          />
        ),
        icon2: (
          <img
            src={Task_Green}
            alt="Task Icon"
          // style={{ width: "18px", height: "18px" }}
          />
        ),
        subMenu: [],
      },
      {
        title: "Daily Project Report",
        path: "ProjectDailyReport",
        icon: (
          <img
            src={Task}
            alt="Task Icon"
          // style={{ width: "18px", height: "18px" }}
          />
        ),
        icon2: (
          <img
            src={Task_Green}
            alt="Task Icon"
          // style={{ width: "18px", height: "18px" }}
          />
        ),
        subMenu: [],
      },
      {
        title: "Attendance Monitor",
        path: "timeLoggerAttendance",
        icon: (
          <img
            src={Attendance}
            alt="Attendance Icon"
          />
        ),
        icon2: (
          <img
            src={Attendance}
            alt="Attendance Icon"
          />
        ),
        subMenu: [],
      },
    ],
  },
  {
    title: "Monthly Reports",
    path: "#",
    icon: (
      <img
        src={Task}
        alt="Task Icon"
      // style={{ width: "18px", height: "18px" }}
      />
    ),
    icon2: (
      <img
        src={Task_Green}
        alt="Task Icon"
      // style={{ width: "18px", height: "18px" }}
      />
    ),
    subMenu: [
      // {
      //   title: "Project Report",
      //   path: "projectReport",
      //   icon: (
      //     <img
      //       src={Task}
      //       alt="Task Icon"
      //     // style={{ width: "18px", height: "18px" }}
      //     />
      //   ),
      //   icon2: (
      //     <img
      //       src={Task_Green}
      //       alt="Task Icon"
      //     // style={{ width: "18px", height: "18px" }}
      //     />
      //   ),
      // },
      {
        title: "Candidate Report",
        path: "candidateHistory",
        icon: (
          <img
            src={""}
            alt="Reverted Icon"
          // style={{ width: "18px", height: "16px" }}
          />
        ),
        icon2: (
          <img
            src={Attendance}
            alt="Reverted Icon"
          // style={{ width: "18px", height: "16px" }}
          />
        ),
      },
      {
        title: "Project Working Report",
        path: "projectworkingreport",
        icon: (
          <img
            src={""}
            alt="Reverted Icon"
          // style={{ width: "18px", height: "16px" }}
          />
        ),
        icon2: (
          <img
            src={Attendance}
            alt="Reverted Icon"
          // style={{ width: "18px", height: "16px" }}
          />
        ),
      },
      {
        title: "Parent Task Report",
        path: "parenttaskreport",
        icon: (
          <img
            src={""}
            alt="Parent Task Report Icon"
          />
        ),
        icon2: (
          <img
            src={Attendance}
            alt="Parent Task Report Icon"
          />
        ),
      },
      {
        title: "Task Report",
        path: "taskreport",
        icon: (
          <img
            src={""}
            alt="Task Report Icon"
          />
        ),
        icon2: (
          <img
            src={Attendance}
            alt="Task Report Icon"
          />
        ),
      },
      {
        title: "Issue wise report",
        path: "issuewisereport",
        icon: (
          <img
            src={""}
            alt="Issue Wise Report Icon"
          />
        ),
        icon2: (
          <img
            src={Attendance}
            alt="Issue Wise Report Icon"
          />
        ),
      },
    ],
  },
  {
    title: "Management",
    path: "shifts",
    icon: (
      <img
        src={PublicHoliday}
        alt="Public Holiday Icon"
      // style={{ width: "24px", height: "24px" }}
      />
    ),
    icon2: (
      <img
        src={PublicHoliday_Green}
        alt="Public Holiday Icon"
      // style={{ width: "24px", height: "24px" }}
      />
    ),
    subMenu: [
      {
        title: "Shifts",
        path: "shifts",
        icon: (
          <img
            src={PublicHoliday}
            alt="Public Holiday Icon"
          // style={{ width: "24px", height: "24px" }}
          />
        ),
        icon2: (
          <img
            src={PublicHoliday_Green}
            alt="Public Holiday Icon"
          // style={{ width: "24px", height: "24px" }}
          />
        ),
        subMenu: [],
      },
      {
        title: "Project",
        path: "project",
        icon: (
          <img
            src={Project}
            alt="Project Icon"
          // style={{ width: "16px", height: "18px" }}
          />
        ),
        icon2: (
          <img
            src={Project_Green}
            alt="Project Icon"
          // style={{ width: "16px", height: "18px" }}
          />
        ),
        subMenu: [],
      },
      {
        title: "Public Holiday",
        path: "publicHoliday",
        icon: (
          <img
            src={PublicHoliday}
            alt="Public Holiday Icon"
          // style={{ width: "24px", height: "24px" }}
          />
        ),
        icon2: (
          <img
            src={PublicHoliday_Green}
            alt="Public Holiday Icon"
          // style={{ width: "24px", height: "24px" }}
          />
        ),
        subMenu: [],
      },
    ],
  },
  {
    title: "Settings",
    path: "permissionManagement",
    icon: <SecurityIcon sx={{ color: "#71717A" }} />,
    icon2: <SecurityIcon sx={{ color: "#20a9b3ff" }} />,
    subMenu: [
      {
        title: "Permission",
        path: "permissionManagement",
        icon: <SecurityIcon sx={{ color: "#71717A" }} />,
        icon2: <SecurityIcon sx={{ color: "#20a9b3ff" }} />,
        subMenu: []
      },
      {
        title: "App Download",
        path: "appDownloadUpload",
        icon: <CloudDownload sx={{ color: "#71717A" }} />,
        icon2: <CloudDownload sx={{ color: "#20a9b3ff" }} />,
        subMenu: [],
      },
      {
        title: "System Monitoring",
        path: "systemMonitoring",
        icon: <SpeedIcon sx={{ color: "#71717A" }} />,
        icon2: <SpeedIcon sx={{ color: "#20a9b3ff" }} />,
        subMenu: [],
      },
      {
        title: "Payroll Management",
        path: "payrollManagement",
        icon: <AssignmentIcon sx={{ color: "#71717A" }} />,
        icon2: <AssignmentIcon sx={{ color: "#20a9b3ff" }} />,
        subMenu: [],
      },
      {
        title: "Logger Settings",
        path: "timeLoggerOrgs",
        icon: <BusinessIcon sx={{ color: "#71717A" }} />,
        icon2: <BusinessIcon sx={{ color: "#20a9b3ff" }} />,
        subMenu: [],
      },
    ],
  },
  {
    title: "Vault",
    path: "vault",
    icon: <Inventory2OutlinedIcon />,
    icon2: <Inventory2OutlinedIcon style={{ color: "#008080" }} />,
    subMenu: [],
  },
];

const userMenu = [
  {
    title: "Dashboard",
    path: "dashboard",
    icon: (
      <img
        src={DashBoard}
        alt="Dashboard Icon"
      // style={{ width: "19px", height: "18px" }}
      />
    ),
    icon2: (
      <img
        src={DashBoard_Green}
        alt="Dashboard Icon"
      // style={{ width: "19px", height: "18px" }}
      />
    ),
    subMenu: [],
  },
  // {
  //   title: "User",
  //   path: "user",
  //   icon: <PeopleAltOutlinedIcon />,
  //   subMenu: [],
  // },
  {
    title: "Tasks",
    path: "tasks",
    icon: (
      <img
        src={Task}
        alt="Task Icon"
      // style={{ width: "18px", height: "18px" }}
      />
    ),
    icon2: (
      <img
        src={Task_Green}
        alt="Task Icon"
      // style={{ width: "18px", height: "18px" }}
      />
    ),
    subMenu: [
      {
        title: "Parent Task",
        path: "parentTask",
        icon: (
          <img
            src={Task}
            alt="Task Icon"
          // style={{ width: "18px", height: "18px" }}
          />
        ),
        icon2: (
          <img
            src={Task_Green}
            alt="Task Icon"
          // style={{ width: "18px", height: "18px" }}
          />
        ),
        subMenu: [],
      },
      {
        title: "Task",
        path: "taskManagement",
        icon: (
          <img
            src={Task}
            alt="Task Icon"
          // style={{ width: "18px", height: "18px" }}
          />
        ),
        icon2: (
          <img
            src={Task_Green}
            alt="Task Icon"
          // style={{ width: "18px", height: "18px" }}
          />
        ),
        subMenu: [],
      },
      {
        title: "Bugs",
        path: "bugManagement",
        icon: (
          <img
            src={Bug}
            alt="Bug Icon"
          // style={{ width: "18px", height: "18px" }}
          />
        ),
        icon2: (
          <img
            src={Bug_Green}
            alt="Bug Icon"
          // style={{ width: "18px", height: "18px" }}
          />
        ),
        subMenu: [],
      },
      {
        title: "Time Sheet",
        path: "timeSheet",
        icon: (
          <img
            src={Task}
            alt="Time Sheet Icon"
          // style={{ width: "18px", height: "18px" }}
          />
        ),
        icon2: (
          <img
            src={Task_Green}
            alt="Time Sheet Icon"
          // style={{ width: "18px", height: "18px" }}
          />
        ),
        subMenu: [],
      },
    ],
  },
  {
    title: "Todo Task",
    path: "todoTask",
    icon: (
      <img
        src={Task}
        alt="Task Icon"
      // style={{ width: "18px", height: "18px" }}
      />
    ),
    icon2: (
      <img
        src={Task_Green}
        alt="Task Icon"
      // style={{ width: "18px", height: "18px" }}
      />
    ),
    subMenu: [],
  },
  {
    title: "Users",
    path: "users",
    icon: (
      <img
        src={Employee}
        alt="Employee Icon"
      // style={{ width: "19px", height: "18px" }}
      />
    ),
    icon2: (
      <img
        src={Employee_Green}
        alt="Employee Icon"
      // style={{ width: "19px", height: "18px" }}
      />
    ),
    subMenu: [
      {
        title: "Employee",
        path: "employee",
        icon: (
          <img
            src={Employee}
            alt="Employee Icon"
          // style={{ width: "19px", height: "18px" }}
          />
        ),
        icon2: (
          <img
            src={Employee_Green}
            alt="Employee Icon"
          // style={{ width: "19px", height: "18px" }}
          />
        ),
        subMenu: [],
      },
      {
        title: "Manager",
        path: "Manager",
        icon: (
          <img
            src={Employee}
            alt="Employee Icon"
          // style={{ width: "19px", height: "18px" }}
          />
        ),
        icon2: (
          <img
            src={Employee_Green}
            alt="Employee Icon"
          // style={{ width: "19px", height: "18px" }}
          />
        ),
        subMenu: [],
      },
      {
        title: "Client",
        path: "client",
        icon: (
          <img
            src={Client}
            alt="Client Icon"
          // style={{ width: "18px", height: "16px" }}
          />
        ),
        icon2: (
          <img
            src={Client_Green}
            alt="Client Icon"
          // style={{ width: "18px", height: "16px" }}
          />
        ),
        subMenu: [],
      },
    ],
  },
  // {
  //   title: "Request",
  //   path: "request",
  //   icon: <img src={Task} alt="Task Icon" />,
  //   icon2: <img src={Task_Green} alt="Task Icon" />,
  //   subMenu: [],
  // },
  {
    title: "Leave",
    path: "leaveManagement",
    icon: (
      <img
        src={Leave}
        alt="Leave Icon"
      // style={{ width: "21px", height: "18px" }}
      />
    ),
    icon2: (
      <img
        src={Leave_Green}
        alt="Leave Icon"
      // style={{ width: "21px", height: "18px" }}
      />
    ),
    subMenu: [
      {
        title: "Leave Apply",
        path: "leaveManagement",
        icon: (
          <img
            src={Leave}
            alt="Leave Icon"
          />
        ),
        icon2: (
          <img
            src={Leave_Green}
            alt="Leave Icon"
          />
        ),
      },
      {
        title: "Compoff",
        path: "earnedLeaveRequests",
        icon: (
          <img
            src={Leave}
            alt="Leave Icon"
          />
        ),
        icon2: (
          <img
            src={Leave_Green}
            alt="Leave Icon"
          />
        ),
      },
      {
        title: "Leave Summary",
        path: "leaveSummary",
        icon: (
          <img
            src={Leave}
            alt="Leave Icon"
          />
        ),
        icon2: (
          <img
            src={Leave_Green}
            alt="Leave Icon"
          />
        ),
      },
    ],
  },
  {
    title: "Attendance",
    path: "attendance",
    icon: (
      <img
        src={Attendance}
        alt="Attendance Icon"
      // style={{ width: "18px", height: "16px" }}
      />
    ),
    icon2: (
      <img
        src={Attendance}
        alt="Attendance Icon"
      // style={{ width: "18px", height: "16px" }}
      />
    ),
  },
  {
    title: "Reverted",
    path: "reverted",
    icon: (
      <img
        src={Attendance}
        alt="Reverted Icon"
      // style={{ width: "18px", height: "16px" }}
      />
    ),
    icon2: (
      <img
        src={Attendance}
        alt="Reverted Icon"
      // style={{ width: "18px", height: "16px" }}
      />
    ),
  },
  {
    title: "Daily Reports",
    path: "time-tracker",
    icon: (
      <img
        src={Client}
        alt="Time Tracker Icon"
      // style={{ width: "18px", height: "16px" }}
      />
    ),
    icon2: (
      <img
        src={Client_Green}
        alt="Time Tracker Icon"
      // style={{ width: "18px", height: "16px" }}
      />
    ),
    subMenu: [
      {
        title: "Work Activity",
        path: "time-tracker",
        icon: (
          <img
            src={Client}
            alt="Time Tracker Icon"
          // style={{ width: "18px", height: "16px" }}
          />
        ),
        icon2: (
          <img
            src={Client_Green}
            alt="Time Tracker Icon"
          // style={{ width: "18px", height: "16px" }}
          />
        ),
        subMenu: [],
      },
      {
        title: "App & Site Usage",
        path: "app-usage",
        icon: (
          <img
            src={Client}
            alt="App Usage Icon"
          />
        ),
        icon2: (
          <img
            src={Client_Green}
            alt="App Usage Icon"
          />
        ),
        subMenu: [],
      },
      {
        title: "Daily Working Report",
        path: "DailyWorkingReport",
        icon: (
          <img
            src={Task}
            alt="Task Icon"
          // style={{ width: "18px", height: "18px" }}
          />
        ),
        icon2: (
          <img
            src={Task_Green}
            alt="Task Icon"
          // style={{ width: "18px", height: "18px" }}
          />
        ),
        subMenu: [],
      },
      {
        title: "Daily Project Report",
        path: "ProjectDailyReport",
        icon: (
          <img
            src={Task}
            alt="Task Icon"
          // style={{ width: "18px", height: "18px" }}
          />
        ),
        icon2: (
          <img
            src={Task_Green}
            alt="Task Icon"
          // style={{ width: "18px", height: "18px" }}
          />
        ),
        subMenu: [],
      },
      {
        title: "Attendance Monitor",
        path: "timeLoggerAttendance",
        icon: (
          <img
            src={Attendance}
            alt="Attendance Icon"
          />
        ),
        icon2: (
          <img
            src={Attendance}
            alt="Attendance Icon"
          />
        ),
        subMenu: [],
      },
    ],
  },
  {
    title: "Monthly Reports",
    path: "#",
    icon: (
      <img
        src={Task}
        alt="Task Icon"
      // style={{ width: "18px", height: "18px" }}
      />
    ),
    icon2: (
      <img
        src={Task_Green}
        alt="Task Icon"
      // style={{ width: "18px", height: "18px" }}
      />
    ),
    subMenu: [
      // {
      //   title: "Project Report",
      //   path: "projectReport",
      //   icon: (
      //     <img
      //       src={Task}
      //       alt="Task Icon"
      //     // style={{ width: "18px", height: "18px" }}
      //     />
      //   ),
      //   icon2: (
      //     <img
      //       src={Task_Green}
      //       alt="Task Icon"
      //     // style={{ width: "18px", height: "18px" }}
      //     />
      //   ),
      // },
      {
        title: "Candidate Report",
        path: "candidateHistory",
        icon: (
          <img
            src={""}
            alt="Reverted Icon"
          // style={{ width: "18px", height: "16px" }}
          />
        ),
        icon2: (
          <img
            src={Attendance}
            alt="Reverted Icon"
          // style={{ width: "18px", height: "16px" }}
          />
        ),
      },
      {
        title: "Project Working Report",
        path: "projectworkingreport",
        icon: (
          <img
            src={""}
            alt="Reverted Icon"
          // style={{ width: "18px", height: "16px" }}
          />
        ),
        icon2: (
          <img
            src={Attendance}
            alt="Reverted Icon"
          // style={{ width: "18px", height: "16px" }}
          />
        ),
      },
      {
        title: "Parent Task Report",
        path: "parenttaskreport",
        icon: (
          <img
            src={""}
            alt="Parent Task Report Icon"
          />
        ),
        icon2: (
          <img
            src={Attendance}
            alt="Parent Task Report Icon"
          />
        ),
      },
      {
        title: "Task Report",
        path: "taskreport",
        icon: (
          <img
            src={""}
            alt="Task Report Icon"
          />
        ),
        icon2: (
          <img
            src={Attendance}
            alt="Task Report Icon"
          />
        ),
      },
      {
        title: "Issue wise report",
        path: "issuewisereport",
        icon: (
          <img
            src={""}
            alt="Issue Wise Report Icon"
          />
        ),
        icon2: (
          <img
            src={Attendance}
            alt="Issue Wise Report Icon"
          />
        ),
      },
    ],
  },
  {
    title: "Management",
    path: "shifts",
    icon: (
      <img
        src={PublicHoliday}
        alt="Public Holiday Icon"
      // style={{ width: "24px", height: "24px" }}
      />
    ),
    icon2: (
      <img
        src={PublicHoliday_Green}
        alt="Public Holiday Icon"
      // style={{ width: "24px", height: "24px" }}
      />
    ),
    subMenu: [
      {
        title: "Shifts",
        path: "shifts",
        icon: (
          <img
            src={PublicHoliday}
            alt="Public Holiday Icon"
          // style={{ width: "24px", height: "24px" }}
          />
        ),
        icon2: (
          <img
            src={PublicHoliday_Green}
            alt="Public Holiday Icon"
          // style={{ width: "24px", height: "24px" }}
          />
        ),
        subMenu: [],
      },
      {
        title: "Project",
        path: "project",
        icon: (
          <img
            src={Project}
            alt="Project Icon"
          // style={{ width: "16px", height: "18px" }}
          />
        ),
        icon2: (
          <img
            src={Project_Green}
            alt="Project Icon"
          // style={{ width: "16px", height: "18px" }}
          />
        ),
        subMenu: [],
      },
    ],
  },
  {
    title: "Public Holiday",
    path: "publicHoliday",
    icon: (
      <img
        src={PublicHoliday}
        alt="Public Holiday Icon"
      // style={{ width: "24px", height: "24px" }}
      />
    ),
    icon2: (
      <img
        src={PublicHoliday_Green}
        alt="Public Holiday Icon"
      // style={{ width: "24px", height: "24px" }}
      />
    ),
    subMenu: [],
  },
   {
      title: "App Download",
      path: "appDownloadUpload",
      icon: <CloudDownload sx={{ color: "#71717A" }} />,
      icon2: <CloudDownload sx={{ color: "#20a9b3ff" }} />,
      subMenu: [],
    },
  {
    title: "Settings",
    path: "permissionManagement",
    icon: <SecurityIcon sx={{ color: "#71717A" }} />,
    icon2: <SecurityIcon sx={{ color: "#20a9b3ff" }} />,
    subMenu: [
      {
        title: "Permission",
        path: "permissionManagement",
        icon: <SecurityIcon sx={{ color: "#71717A" }} />,
        icon2: <SecurityIcon sx={{ color: "#20a9b3ff" }} />,
        subMenu: []
      },
      {
        title: "System Monitoring",
        path: "systemMonitoring",
        icon: <SpeedIcon sx={{ color: "#71717A" }} />,
        icon2: <SpeedIcon sx={{ color: "#20a9b3ff" }} />,
        subMenu: [],
      },
      {
        title: "Payroll Management",
        path: "payrollManagement",
        icon: <AssignmentIcon sx={{ color: "#71717A" }} />,
        icon2: <AssignmentIcon sx={{ color: "#20a9b3ff" }} />,
        subMenu: [],
      },
      {
        title: "Logger Settings",
        path: "timeLoggerOrgs",
        icon: <BusinessIcon sx={{ color: "#71717A" }} />,
        icon2: <BusinessIcon sx={{ color: "#20a9b3ff" }} />,
        subMenu: [],
      },
    ],
  },
  {
    title: "Vault",
    path: "vault",
    icon: <Inventory2OutlinedIcon />,
    icon2: <Inventory2OutlinedIcon style={{ color: "#008080" }} />,
    subMenu: [],
  },
];

const ManagerMenu = [
  {
    title: "Dashboard",
    path: "dashboard",
    icon: (
      <img
        src={DashBoard}
        alt="Dashboard Icon"
      // style={{ width: "19px", height: "18px" }}
      />
    ),
    icon2: (
      <img
        src={DashBoard_Green}
        alt="Dashboard Icon"
      // style={{ width: "19px", height: "18px" }}
      />
    ),
    subMenu: [],
  },
  // {
  //   title: "User",
  //   path: "user",
  //   icon: <PeopleAltOutlinedIcon />,
  //   subMenu: [],
  // },
  {
    title: "Tasks",
    path: "tasks",
    icon: (
      <img
        src={Task}
        alt="Task Icon"
      // style={{ width: "18px", height: "18px" }}
      />
    ),
    icon2: (
      <img
        src={Task_Green}
        alt="Task Icon"
      // style={{ width: "18px", height: "18px" }}
      />
    ),
    subMenu: [
      {
        title: "Parent Task",
        path: "parentTask",
        icon: (
          <img
            src={Task}
            alt="Task Icon"
          // style={{ width: "18px", height: "18px" }}
          />
        ),
        icon2: (
          <img
            src={Task_Green}
            alt="Task Icon"
          // style={{ width: "18px", height: "18px" }}
          />
        ),
        subMenu: [],
      },
      {
        title: "Task",
        path: "taskManagement",
        icon: (
          <img
            src={Task}
            alt="Task Icon"
          // style={{ width: "18px", height: "18px" }}
          />
        ),
        icon2: (
          <img
            src={Task_Green}
            alt="Task Icon"
          // style={{ width: "18px", height: "18px" }}
          />
        ),
        subMenu: [],
      },
      {
        title: "Bugs",
        path: "bugManagement",
        icon: (
          <img
            src={Bug}
            alt="Bug Icon"
          // style={{ width: "18px", height: "18px" }}
          />
        ),
        icon2: (
          <img
            src={Bug_Green}
            alt="Bug Icon"
          // style={{ width: "18px", height: "18px" }}
          />
        ),
        subMenu: [],
      },
      {
        title: "Time Sheet",
        path: "timeSheet",
        icon: (
          <img
            src={Task}
            alt="Time Sheet Icon"
          // style={{ width: "18px", height: "18px" }}
          />
        ),
        icon2: (
          <img
            src={Task_Green}
            alt="Time Sheet Icon"
          // style={{ width: "18px", height: "18px" }}
          />
        ),
        subMenu: [],
      },
    ],
  },
  {
    title: "Todo Task",
    path: "todoTask",
    icon: (
      <img
        src={Task}
        alt="Task Icon"
      // style={{ width: "18px", height: "18px" }}
      />
    ),
    icon2: (
      <img
        src={Task_Green}
        alt="Task Icon"
      // style={{ width: "18px", height: "18px" }}
      />
    ),
    subMenu: [],
  },
  {
    title: "Users",
    path: "users",
    icon: (
      <img
        src={Employee}
        alt="Employee Icon"
      // style={{ width: "19px", height: "18px" }}
      />
    ),
    icon2: (
      <img
        src={Employee_Green}
        alt="Employee Icon"
      // style={{ width: "19px", height: "18px" }}
      />
    ),
    subMenu: [
      {
        title: "Employee",
        path: "employee",
        icon: (
          <img
            src={Employee}
            alt="Employee Icon"
          // style={{ width: "19px", height: "18px" }}
          />
        ),
        icon2: (
          <img
            src={Employee_Green}
            alt="Employee Icon"
          // style={{ width: "19px", height: "18px" }}
          />
        ),
        subMenu: [],
      },
      {
        title: "Manager",
        path: "Manager",
        icon: (
          <img
            src={Employee}
            alt="Employee Icon"
          // style={{ width: "19px", height: "18px" }}
          />
        ),
        icon2: (
          <img
            src={Employee_Green}
            alt="Employee Icon"
          // style={{ width: "19px", height: "18px" }}
          />
        ),
        subMenu: [],
      },
      {
        title: "Client",
        path: "client",
        icon: (
          <img
            src={Client}
            alt="Client Icon"
          // style={{ width: "18px", height: "16px" }}
          />
        ),
        icon2: (
          <img
            src={Client_Green}
            alt="Client Icon"
          // style={{ width: "18px", height: "16px" }}
          />
        ),
        subMenu: [],
      },
    ],
  },
  // {
  //   title: "Request",
  //   path: "request",
  //   icon: <img src={Task} alt="Task Icon" />,
  //   icon2: <img src={Task_Green} alt="Task Icon" />,
  //   subMenu: [],
  // },
  {
    title: "Leave",
    path: "leaveManagement",
    icon: (
      <img
        src={Leave}
        alt="Leave Icon"
      // style={{ width: "21px", height: "18px" }}
      />
    ),
    icon2: (
      <img
        src={Leave_Green}
        alt="Leave Icon"
      // style={{ width: "21px", height: "18px" }}
      />
    ),
    subMenu: [
      {
        title: "Approvel Pending",
        path: "leaveManagement",
        icon: (
          <img
            src={Leave}
            alt="Leave Icon"
          />
        ),
        icon2: (
          <img
            src={Leave_Green}
            alt="Leave Icon"
          />
        ),
      },
      {
        title: "Compoff",
        path: "earnedLeaveRequests",
        icon: (
          <img
            src={Leave}
            alt="Leave Icon"
          />
        ),
        icon2: (
          <img
            src={Leave_Green}
            alt="Leave Icon"
          />
        ),
      },
      {
        title: "Leave Summary",
        path: "leaveSummary",
        icon: (
          <img
            src={Leave}
            alt="Leave Icon"
          />
        ),
        icon2: (
          <img
            src={Leave_Green}
            alt="Leave Icon"
          />
        ),
      },
    ],
  },
  {
    title: "Attendance",
    path: "#",
    icon: (
      <img
        src={Attendance}
        alt="Task Icon"
      // style={{ width: "18px", height: "18px" }}
      />
    ),
    icon2: (
      <img
        src={Attendance}
        alt="Task Icon"
      // style={{ width: "18px", height: "18px" }}
      />
    ),
    subMenu: [
      {
        title: "Attendance Report",
        path: "attendance",
        icon: (
          <img
            src={Attendance}
            alt="Attendance Icon"
          // style={{ width: "18px", height: "16px" }}
          />
        ),
        icon2: (
          <img
            src={Attendance}
            alt="Attendance Icon"
          // style={{ width: "18px", height: "16px" }}
          />
        ),
      },
      {
        title: "Reverted",
        path: "reverted",
        icon: (
          <img
            src={Attendance}
            alt="Reverted Icon"
          // style={{ width: "18px", height: "16px" }}
          />
        ),
        icon2: (
          <img
            src={Attendance}
            alt="Reverted Icon"
          // style={{ width: "18px", height: "16px" }}
          />
        ),
      },
    ]
  },
  {
    title: "Daily Reports",
    path: "time-tracker",
    icon: (
      <img
        src={Client}
        alt="Time Tracker Icon"
      // style={{ width: "18px", height: "16px" }}
      />
    ),
    icon2: (
      <img
        src={Client_Green}
        alt="Time Tracker Icon"
      // style={{ width: "18px", height: "16px" }}
      />
    ),
    subMenu: [
      {
        title: "Work Activity",
        path: "time-tracker",
        icon: (
          <img
            src={Client}
            alt="Time Tracker Icon"
          // style={{ width: "18px", height: "16px" }}
          />
        ),
        icon2: (
          <img
            src={Client_Green}
            alt="Time Tracker Icon"
          // style={{ width: "18px", height: "16px" }}
          />
        ),
        subMenu: [],
      },
      {
        title: "App & Site Usage",
        path: "app-usage",
        icon: (
          <img
            src={Client}
            alt="App Usage Icon"
          />
        ),
        icon2: (
          <img
            src={Client_Green}
            alt="App Usage Icon"
          />
        ),
        subMenu: [],
      },
      {
        title: "Note Approvals",
        path: "note-approvals",
        icon: (
          <img
            src={Client}
            alt="Note Approvals Icon"
          />
        ),
        icon2: (
          <img
            src={Client_Green}
            alt="Note Approvals Icon"
          />
        ),
        subMenu: [],
      },
      {
        title: "Daily Working Report",
        path: "DailyWorkingReport",
        icon: (
          <img
            src={Task}
            alt="Task Icon"
          // style={{ width: "18px", height: "18px" }}
          />
        ),
        icon2: (
          <img
            src={Task_Green}
            alt="Task Icon"
          // style={{ width: "18px", height: "18px" }}
          />
        ),
        subMenu: [],
      },
      {
        title: "Daily Project Report",
        path: "ProjectDailyReport",
        icon: (
          <img
            src={Task}
            alt="Task Icon"
          // style={{ width: "18px", height: "18px" }}
          />
        ),
        icon2: (
          <img
            src={Task_Green}
            alt="Task Icon"
          // style={{ width: "18px", height: "18px" }}
          />
        ),
        subMenu: [],
      },
      {
        title: "Attendance Monitor",
        path: "timeLoggerAttendance",
        icon: (
          <img
            src={Attendance}
            alt="Attendance Icon"
          />
        ),
        icon2: (
          <img
            src={Attendance}
            alt="Attendance Icon"
          />
        ),
        subMenu: [],
      },
    ],
  },
  {
    title: "Monthly Reports",
    path: "#",
    icon: (
      <img
        src={Task}
        alt="Task Icon"
      // style={{ width: "18px", height: "18px" }}
      />
    ),
    icon2: (
      <img
        src={Task_Green}
        alt="Task Icon"
      // style={{ width: "18px", height: "18px" }}
      />
    ),
    subMenu: [
      // {
      //   title: "Project Report",
      //   path: "projectReport",
      //   icon: (
      //     <img
      //       src={Task}
      //       alt="Task Icon"
      //     // style={{ width: "18px", height: "18px" }}
      //     />
      //   ),
      //   icon2: (
      //     <img
      //       src={Task_Green}
      //       alt="Task Icon"
      //     // style={{ width: "18px", height: "18px" }}
      //     />
      //   ),
      // },
      {
        title: "Candidate Report",
        path: "candidateHistory",
        icon: (
          <img
            src={""}
            alt="Reverted Icon"
          // style={{ width: "18px", height: "16px" }}
          />
        ),
        icon2: (
          <img
            src={Attendance}
            alt="Reverted Icon"
          // style={{ width: "18px", height: "16px" }}
          />
        ),
      },
      {
        title: "Project Working Report",
        path: "projectworkingreport",
        icon: (
          <img
            src={""}
            alt="Reverted Icon"
          // style={{ width: "18px", height: "16px" }}
          />
        ),
        icon2: (
          <img
            src={Attendance}
            alt="Reverted Icon"
          // style={{ width: "18px", height: "16px" }}
          />
        ),
      },
      {
        title: "Parent Task Report",
        path: "parenttaskreport",
        icon: (
          <img
            src={""}
            alt="Parent Task Report Icon"
          />
        ),
        icon2: (
          <img
            src={Attendance}
            alt="Parent Task Report Icon"
          />
        ),
      },
      {
        title: "Task Report",
        path: "taskreport",
        icon: (
          <img
            src={""}
            alt="Task Report Icon"
          />
        ),
        icon2: (
          <img
            src={Attendance}
            alt="Task Report Icon"
          />
        ),
      },
      {
        title: "Issue wise report",
        path: "issuewisereport",
        icon: (
          <img
            src={""}
            alt="Issue Wise Report Icon"
          />
        ),
        icon2: (
          <img
            src={Attendance}
            alt="Issue Wise Report Icon"
          />
        ),
      },
    ],
  },
  {
    title: "Management",
    path: "shifts",
    icon: (
      <img
        src={PublicHoliday}
        alt="Public Holiday Icon"
      // style={{ width: "24px", height: "24px" }}
      />
    ),
    icon2: (
      <img
        src={PublicHoliday_Green}
        alt="Public Holiday Icon"
      // style={{ width: "24px", height: "24px" }}
      />
    ),
    subMenu: [
      {
        title: "Shifts",
        path: "shifts",
        icon: (
          <img
            src={PublicHoliday}
            alt="Public Holiday Icon"
          // style={{ width: "24px", height: "24px" }}
          />
        ),
        icon2: (
          <img
            src={PublicHoliday_Green}
            alt="Public Holiday Icon"
          // style={{ width: "24px", height: "24px" }}
          />
        ),
        subMenu: [],
      },
      {
        title: "Project",
        path: "project",
        icon: (
          <img
            src={Project}
            alt="Project Icon"
          // style={{ width: "16px", height: "18px" }}
          />
        ),
        icon2: (
          <img
            src={Project_Green}
            alt="Project Icon"
          // style={{ width: "16px", height: "18px" }}
          />
        ),
        subMenu: [],
      },
      {
        title: "Public Holiday",
        path: "publicHoliday",
        icon: (
          <img
            src={PublicHoliday}
            alt="Public Holiday Icon"
          // style={{ width: "24px", height: "24px" }}
          />
        ),
        icon2: (
          <img
            src={PublicHoliday_Green}
            alt="Public Holiday Icon"
          // style={{ width: "24px", height: "24px" }}
          />
        ),
        subMenu: [],
      },
    ],
  },
  {
    title: "Settings",
    path: "permissionManagement",
    icon: <SecurityIcon sx={{ color: "#71717A" }} />,
    icon2: <SecurityIcon sx={{ color: "#20a9b3ff" }} />,
    subMenu: [
      {
        title: "Permission",
        path: "permissionManagement",
        icon: <SecurityIcon sx={{ color: "#71717A" }} />,
        icon2: <SecurityIcon sx={{ color: "#20a9b3ff" }} />,
        subMenu: []
      },
      {
        title: "App Download",
        path: "appDownloadUpload",
        icon: <CloudDownload sx={{ color: "#71717A" }} />,
        icon2: <CloudDownload sx={{ color: "#20a9b3ff" }} />,
        subMenu: [],
      },
      {
        title: "System Monitoring",
        path: "systemMonitoring",
        icon: <SpeedIcon sx={{ color: "#71717A" }} />,
        icon2: <SpeedIcon sx={{ color: "#20a9b3ff" }} />,
        subMenu: [],
      },
      {
        title: "Payroll Management",
        path: "payrollManagement",
        icon: <AssignmentIcon sx={{ color: "#71717A" }} />,
        icon2: <AssignmentIcon sx={{ color: "#20a9b3ff" }} />,
        subMenu: [],
      },
      {
        title: "Logger Settings",
        path: "timeLoggerOrgs",
        icon: <BusinessIcon sx={{ color: "#71717A" }} />,
        icon2: <BusinessIcon sx={{ color: "#20a9b3ff" }} />,
        subMenu: [],
      },
    ],
  },
];


const FinanceMenu = [
  {
    title: "Dashboard",
    path: "dashboard",
    icon: (
      <img
        src={DashBoard}
        alt="Dashboard Icon"
      />
    ),
    icon2: (
      <img
        src={DashBoard_Green}
        alt="Dashboard Icon"
      />
    ),
    subMenu: [],
  },
];

const clientMenu = [
  {
    title: "Dashboard",
    path: "dashboard",
    icon: (
      <img
        src={DashBoard}
        alt="Dashboard Icon"
      // style={{ width: "19px", height: "18px" }}
      />
    ),
    icon2: (
      <img
        src={DashBoard_Green}
        alt="Dashboard Icon"
      // style={{ width: "19px", height: "18px" }}
      />
    ),
    subMenu: [],
  },
  // {
  //   title: "Task Management",
  //   path: "taskManagement",
  //   icon: <AssignmentIcon />,
  //   subMenu: [],
  // },
  {
    title: "Task",
    path: "clientTaskManagement",
    icon: (
      <img
        src={Task}
        alt="Task Icon"
      // style={{ width: "18px", height: "18px" }}
      />
    ),
    icon2: (
      <img
        src={Task_Green}
        alt="Task Icon"
      // style={{ width: "18px", height: "18px" }}
      />
    ),
    subMenu: [],
  },
  {
    title: "Request",
    path: "request",
    icon: <img src={Task} alt="Task Icon" />,
    icon2: <img src={Task_Green} alt="Task Icon" />,
    subMenu: [],
  },
  {
    title: "Supporting File",
    path: "supportingFileupload",
    icon: <CiFileOn size={25} color="#3F3F46" />,
    icon2: (
      <CiFileOn size={25} color="#055253" />
      // style={{ width: "18px", height: "18px" }}
    ),
    subMenu: [],
  },
  {
    title: "Client Task Report",
    path: "clientTaskReport",
    icon: (
      <img
        src={Task}
        alt="Task Icon"
      // style={{ width: "18px", height: "18px" }}
      />
    ),
    icon2: (
      <img
        src={Task_Green}
        alt="Task Icon"
      // style={{ width: "18px", height: "18px" }}
      />
    ),
  },
];

// Map menu paths to permission module keys
export const pathToPermissionMap = {
  dashboard: "dashboard",
  employee: "employee",
  Manager: "manager", // Key in userPermission is "manager"
  taskManagement: "taskManagement",
  bugManagement: "taskManagement", // Bugs use same permission as tasks
  timeSheet: "timeSheet",
  parentTask: "parentTask",
  todoTask: "todoTask",
  client: "client",
  project: "project", // Key in userPermission is "project"
  clientTaskManagement: "clientTaskManagement",
  supportingFileupload: "supportingFileUpload",
  leaveManagement: "leaveManagement",
  earnedLeaveRequests: "earnedLeaveRequests",
  leaveSummary: "leaveSummary",
  myEarnedLeaveRequests: "myEarnedLeaveRequests",
  publicHoliday: "publicHoliday",
  attendance: "attendance",
  "time-tracker": "timeTracker",
  timeTracker: "timeTracker",
  // Manager/admin note queue — gated by the same module as Work Activity; the
  // page itself refuses non-reviewer roles.
  "note-approvals": "timeTracker",
  timeLoggerAttendance: "timeLoggerAttendance",
  timeLoggerOrgs: "timeLoggerOrgs",
  projectReport: "projectReport",
  projectWorkingReport: "projectWorkingReport",
  parenttaskreport: "parentTaskReport",
  dailyWorkingReport: "dailyWorkingReport",
  DailyWorkingReport: "dailyWorkingReport",
  candidateHistory: "candidateHistory",
  reverted: "reverted",
  request: "request",
  shifts: "shifts",
  appDownloadUpload: "appDownload",
  projectworkingreport: "projectWorkingReport", // Specific fix for lowercase path in userMenu
  ProjectDailyReport: "projectDailyReport",
  permissionManagement: "permissionManagement",
  issuewisereport: "issuewisereport",
  taskReport: "taskReport",
  taskreport: "taskreport",
  payrollManagement: "payrollManagement",
  systemMonitoring: "systemMonitoring",
  clientTaskReport: "clientTaskReport",
};

// Filter menu based on user permissions
// Filter menu based on user permissions
export const filterMenuByPermissions = (menu, permissions) => {
  if (!permissions) {
    return [];
  }

  return menu.reduce((acc, item) => {
    // 1. Check strict permission for the item itself
    const permissionKey = pathToPermissionMap[item.path];

    // If explicit permission key exists, must have view=true.
    // If path is '#', we treat it as permissible (container), subject to child check.
    let hasPermission = true;
    if (permissionKey) {
      hasPermission = permissions[permissionKey]?.view === true;
    }

    // 2. Process Submenu (Recursive)
    let filteredSubMenu = [];
    if (item.subMenu && item.subMenu.length > 0) {
      filteredSubMenu = filterMenuByPermissions(item.subMenu, permissions);
    }

    // 3. Decision Logic
    if (item.subMenu && item.subMenu.length > 0) {
      // It's a container with children.
      // Show it ONLY if it has visible children.
      // (Even if the parent itself has permission, an empty dropdown is useless)
      if (filteredSubMenu.length > 0) {
        acc.push({ ...item, subMenu: filteredSubMenu });
      }
    } else {
      // Leaf node or container without children loaded yet
      if (hasPermission) {
        acc.push(item);
      }
    }

    return acc;
  }, []);
};

// An Org Admin gets exactly two modules. This mirrors the backend allowlist in
// configuration/orgAdminAccess.js — every other endpoint is refused for role 7,
// so showing any other menu item would only produce dead links.
const orgAdminMenu = [
  {
    title: "Employee",
    path: "employee",
    icon: <img src={Employee} alt="Employee Icon" />,
    icon2: <img src={Employee_Green} alt="Employee Icon" />,
    subMenu: [],
  },
  {
    title: "Daily Reports",
    path: "time-tracker",
    icon: <img src={Client} alt="Time Tracker Icon" />,
    icon2: <img src={Client_Green} alt="Time Tracker Icon" />,
    subMenu: [
      {
        title: "Work Activity",
        path: "time-tracker",
        icon: <img src={Client} alt="Time Tracker Icon" />,
        icon2: <img src={Client_Green} alt="Time Tracker Icon" />,
        subMenu: [],
      },
      {
        title: "App & Site Usage",
        path: "app-usage",
        icon: <img src={Client} alt="App Usage Icon" />,
        icon2: <img src={Client_Green} alt="App Usage Icon" />,
        subMenu: [],
      },
      {
        title: "Note Approvals",
        path: "note-approvals",
        icon: <img src={Client} alt="Note Approvals Icon" />,
        icon2: <img src={Client_Green} alt="Note Approvals Icon" />,
        subMenu: [],
      },
      {
        title: "Daily Working Report",
        path: "DailyWorkingReport",
        icon: <img src={Task} alt="Task Icon" />,
        icon2: <img src={Task_Green} alt="Task Icon" />,
        subMenu: [],
      },
      {
        title: "Daily Project Report",
        path: "ProjectDailyReport",
        icon: <img src={Task} alt="Task Icon" />,
        icon2: <img src={Task_Green} alt="Task Icon" />,
        subMenu: [],
      },
      {
        title: "Attendance Monitor",
        path: "timeLoggerAttendance",
        icon: <img src={Attendance} alt="Attendance Icon" />,
        icon2: <img src={Attendance} alt="Attendance Icon" />,
        subMenu: [],
      },
    ],
  },
  {
    title: "App Download",
    path: "appDownloadUpload",
    icon: <CloudDownload sx={{ color: "#71717A" }} />,
    icon2: <CloudDownload sx={{ color: "#20a9b3ff" }} />,
    subMenu: [],
  },
];

// Employees created by an Org Admin: App Download only. Mirrors
// ORG_EMPLOYEE_ALLOWED_ROUTES on the backend.
const orgEmployeeMenu = [
  {
    title: "Daily Reports",
    path: "time-tracker",
    icon: <img src={Client} alt="Time Tracker Icon" />,
    icon2: <img src={Client_Green} alt="Time Tracker Icon" />,
    subMenu: [
      {
        title: "Work Activity",
        path: "time-tracker",
        icon: <img src={Client} alt="Time Tracker Icon" />,
        icon2: <img src={Client_Green} alt="Time Tracker Icon" />,
        subMenu: [],
      },
      {
        title: "App & Site Usage",
        path: "app-usage",
        icon: <img src={Client} alt="App Usage Icon" />,
        icon2: <img src={Client_Green} alt="App Usage Icon" />,
        subMenu: [],
      },
      {
        title: "Daily Working Report",
        path: "DailyWorkingReport",
        icon: <img src={Task} alt="Task Icon" />,
        icon2: <img src={Task_Green} alt="Task Icon" />,
        subMenu: [],
      },
    ],
  },
  {
    title: "App Download",
    path: "appDownloadUpload",
    icon: <CloudDownload sx={{ color: "#71717A" }} />,
    icon2: <CloudDownload sx={{ color: "#20a9b3ff" }} />,
    subMenu: [],
  },
];

export {
  superAdminMenu,
  userMenu,
  clientMenu,
  ManagerMenu,
  FinanceMenu,
  orgAdminMenu,
  orgEmployeeMenu,
};
